import React from 'react';
import renderer from 'react-test-renderer';
import '@testing-library/jest-dom';
import {
  fireEvent, render, screen,
} from '@testing-library/react';
import { account, accountTypes, user } from '../../__mocks__/account-data';

import Table from '../../../admin/users/Table';
import api from '../../../../services/api';

global.fetch = jest.fn().mockResolvedValueOnce({ json: () => Promise.resolve({ }) });
api.admin.users.update = jest.fn().mockResolvedValue({ status: 'OK' });

it('renders correctly with props', () => {
  const tree = renderer.create(
    <Table
      users={[{ ...user, account }]}
      accountTypes={accountTypes}
      onDeleted={() => {}}
      onMove={() => {}}
      sortable
      sortBy="name"
      sortDir="asc"
      onSort={() => {}}
      handleEnableUser={() => {}}
      handleDisableUser={() => {}}
      account={false}
    />,
  ).toJSON();
  expect(tree).toMatchSnapshot();
});

it('renders correctly without props', () => {
  const tree = renderer.create(<Table />).toJSON();
  expect(tree).toMatchSnapshot();
});

it('close and update events with status ok', async () => {
  const sort = jest.fn();
  const disable = jest.fn();
  render(
    <Table
      users={[{ ...user, account }]}
      accountTypes={accountTypes}
      onDeleted={() => {}}
      onMove={() => {}}
      sortable
      sortBy="name"
      sortDir="asc"
      onSort={sort}
      handleEnableUser={() => {}}
      handleDisableUser={disable}
      account={false}
    />,
  );

  const optionsButton = await screen.getByText('...');
  expect(optionsButton).toBeInTheDocument();
  fireEvent.click(optionsButton);

  const disableButton = await screen.getByText('Disable User');
  expect(disableButton).toBeInTheDocument();
  fireEvent.click(disableButton);
  expect(disable).toBeCalledTimes(1);

  const userNameColumn = await screen.getByText('User Name');
  fireEvent.click(userNameColumn);
  expect(sort).toBeCalledTimes(1);
});
